<template>
  <div class="apiMarket">
    <h1>API分类</h1>

    <div class="flexBlock">
      <ApiBlock v-for="item in list" :key="item.id" :item="item"></ApiBlock>
    </div>
  </div>
</template>

<script>
import { getInterFaceList } from '@/api/common'
import ApiBlock from '@/components/ApiBlock.vue'
export default {
  data () {
    return {
      list: []
    }
  },
  methods: {
    async getList () {
      const result = await getInterFaceList()
      this.list = result.data
    }
  },
  async created () {
    this.getList()
  },
  computed: {},
  components: {
    ApiBlock
  }
}
</script>

<style lang="less" scoped>
.apiMarket {
  margin: 0 auto;
  width: 1000px;
  padding: 20px;

  h1 {
    padding: 10px 10px 20px;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }

  .flexBlock {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .apiMarket {
    width: 100%;
    padding: 12px;

    h1 {
      font-size: 18px;
      padding: 10px 0 15px;
    }

    .flexBlock {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 6px;
    }
  }
}
</style>
